
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cdc-protegido",
      function () {
        return require("private-next-pages/cdc-protegido.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cdc-protegido"])
      });
    }
  